import Axios from 'axios';
import Instance from '../instance';
import WixConfig from '../../config/wix';

/**
 * -------------------------------------
 * POST API request.
 * -------------------------------------
 * 
 * @param path
 * @param data
 * @param $uploadsFile
 * 
 */

const PostRequest = (path: string, data: any, uploadsFile = false) => {

    /**
    *--------------------------------------------------------------------------
    * Generating URL
    *--------------------------------------------------------------------------
    * URL = Base URL + Path
    *--------------------------------------------------------------------------
    *
    */

    let baseUrl = WixConfig.backendApiBaseUrl;
    let url = baseUrl + path;

    /**
    *--------------------------------------------------------------------------
    * Get instance
    *--------------------------------------------------------------------------
    * Assumed that instance is appended in query param by Wix.
    *--------------------------------------------------------------------------
    * 
    */

    let instance = Instance.get();

    /*
    | ------------------------------------------------------------
    | Define Content-type based on whether file(s) is uploaded
    | or not
    | ------------------------------------------------------------
    |
    */

    let contentType = 'application/json';
    if (uploadsFile) {
        contentType = "multipart/form-data";

        let formData = new FormData();
        for (var key in data) {
            formData.append(key, data[key]);
        }
        data = formData;
    }

    /**
    *--------------------------------------------------------------------------
    * Preparing headers
    *--------------------------------------------------------------------------
    * 
    */

    Axios.defaults.withCredentials = true;
    let headers = {
        accept: 'application/json',
        'Authorization': instance,
        'Content-Type': contentType
    };

    /**
    *--------------------------------------------------------------------------
    * Send request
    *--------------------------------------------------------------------------
    * Send a POST request and return a promise that will resolve to JSON
    * response (error or success).
    *--------------------------------------------------------------------------
    * 
    */

    return new Promise((resolve, reject) => {
        Axios.post(
            url,
            data,
            { headers: headers }
        )
            .then((responseJSON) => resolve(responseJSON.data))
            .catch((error) => reject(error.response?.data))
    });

}

export default PostRequest;
